import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

import { MessageComponent } from '../shared/component/message/message.component';
import { ApiModalComponent } from './api-modal/api-modal.component';
import { AuthService } from '../shared/service/auth.service';
import { UserService } from '../shared/service/user.service';
import { UserModel } from '../shared/model/user.model';

import { environment } from '../../environments/environment';
import { AiConfig, AiService } from '../shared/service/ai.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    @ViewChild(MessageComponent) message: MessageComponent;
    @ViewChild(ApiModalComponent) apiModal: ApiModalComponent;

    ipIsOk = false;
    appVersion = '';
    isUserLoggedIn: boolean;
    user: UserModel = new UserModel();
    css: any = { login: '', password: '' };

    constructor(
        private translateService: TranslateService,
        private userService: UserService, 
        private authService: AuthService,
        private aiService: AiService,
        private router: Router, 
    ) {}

    ngOnInit() {
        this.loadVersion();
        this.validateAPIUrl();

        this.isUserLoggedIn = this.authService.hasTokenLocalStorage();

        if (this.isUserLoggedIn) this.router.navigate(['/']);
    }

    validateAPIUrl() {
        let apiAddress = `https://`;

        if (!this.authService.getApiIP()) {
            const { hostname } = window.location;
            // const portNumber = this.getDynamicPort(hostname);

            if (
                !hostname.includes('-web')
                // !portNumber && !hostname.includes('easyprocheck')
            ) {
                apiAddress += `${hostname}:3030`;
            } else {
                // server-web-porta => server-api-porta.easyprocheck..
                apiAddress += `${hostname.replace('web', 'api')}`;
            }

            this.authService.setApiIP(apiAddress);
            this.userService.setApiIp(apiAddress);
        }

        this.testConnection();
    }

    getDynamicPort(url: string): number | null {
        const portPattern = /-(\d+)\./;

        // Execute the regex pattern on the URL
        const match = portPattern.exec(url);

        // The first capturing group will contain the port number
        if (match) {
            return parseInt(match[1], 10);
        }

        return null;
    }

    loadVersion() {
        this.appVersion = environment.version;
    }

    isChineseCustomer() {
        const { href } = window.location;
        return href.includes('app-fng.com') || href.includes('112.74.170.246');
    }

    openApiModal() {
        this.apiModal.display = true;
    }

    onSaveApiAddress() {
        this.testConnection();
        this.userService.setApiIp(this.authService.getApiIP());
    }

    testConnection() {
        this.authService.testConnection(this.authService.getApiIP()).subscribe((res) => {
            this.ipIsOk = true;
        }, err => {
            this.ipIsOk = false;
            this.message.error(this.translate('api_no_connection'))
        });
    }

    onSubmit() {
        if(!this.ipIsOk) {
            return this.message.error(this.translate('api_no_connection'));
        }
        this.userService.login(this.user).subscribe(r => {
            this.authService.setLoginState(r);
            this.loadAiConfig();
            this.router.navigate(['/']);
        }, ({ error }: HttpErrorResponse) => {
            this.message.error(error.message);
        }
        );
    }

    loadAiConfig() {
        this.aiService.getConfig().pipe(take(1)).subscribe(
            (config: AiConfig) => {
                this.authService.setUserConfig({ aiEnabled: config.enabled });
            },
        );
    }

    onBlur(el, name) {
        if (el.value) {
            this.css[name] = 'ui-state-filled';
        } else {
            this.css[name] = '';
        }
    }

    translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/login/login.component.ts